<template>
    <div class="d-flex">
        <div class="ml-3">
            <admin-date-picker
                :label="title + ' 시작 일'"
                :date.sync="innerStartDate"
            />
        </div>
        <div class="ml-3">
            <admin-time-picker
                :label="title + ' 시작 시간'"
                :time.sync="innerStartTime"
            />
        </div>
        <div class="ml-3">
            <admin-date-picker
                :label="title + ' 종료 일'"
                :date.sync="innerEndDate"
            />
        </div>
        <div class="ml-3">
            <admin-time-picker
                :label="title + ' 종료 시간'"
                :time.sync="innerEndTime"
            />
        </div>
    </div>
</template>

<script>
import AdminDatePicker from "@/components/input/AdminDatePicker";
import AdminTimePicker from "@/components/input/AdminTimePicker";

export default {
    name: "AdminDateTimePicker",
    props: {
        title: String,
        startDate: String,
        startTime: String,
        endDate: String,
        endTime: String,
    },
    components: {
        AdminDatePicker,
        AdminTimePicker,
    },
    data() {
      return {
          innerStartDate: this.startDate,
          innerStartTime: this.startTime,
          innerEndDate: this.endDate,
          innerEndTime: this.endTime,
      }
    },
    watch: {
        innerStartDate(value) {
            this.$emit('update:startDate', value)
        },
        innerStartTime(value) {
            this.$emit('update:startTime', value)
        },
        innerEndDate(value) {
            this.$emit('update:endDate', value)
        },
        innerEndTime(value) {
            this.$emit('update:endTime', value)
        }
    }
}
</script>

<style scoped>
</style>
